import { portalLink } from "../utils/portal";

function Opportunities() {
  return (
    <section className="opps" id="opportunities">
      <div className="opps-hdr">
        <div className="eyebrow rv">
          <div className="eyebrow-dash"></div>
          <span className="eyebrow-text" style={{ color: "#a6a39b" }}>
            What IPDI Offers
          </span>
        </div>

        <h2 className="sec-title lt rv d1">
          Every Opportunity, <em>One Ecosystem.</em>
        </h2>
      </div>

      <div className="opps-grid rv">
        {/* Card 1 */}
        <div className="opp-card">
          <div
            className="opp-card-img"
            style={{
              backgroundImage:
                "url('https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=900&q=70')",
            }}
          ></div>

          <div className="opp-card-overlay"></div>

          <div className="opp-card-body">
            <div className="opp-card-tag">01 · Upskill</div>

            <h3 className="opp-card-title">
              Master industry-grade skills that firms actually hire for.
            </h3>

            <p className="opp-card-desc">
              Software training, design theory, project management, and BIM —
              built with top Indian firms.
            </p>

            <a href="#programs" className="opp-card-cta">
              Explore Programs <span className="opp-card-arrow">→</span>
            </a>
          </div>
        </div>

        {/* Card 2 */}
        <div className="opp-card">
          <div
            className="opp-card-img"
            style={{
              backgroundImage:
                "url('https://images.unsplash.com/photo-1497366216548-37526070297c?w=900&q=70')",
            }}
          ></div>

          <div className="opp-card-overlay"></div>

          <div className="opp-card-body">
            <div className="opp-card-tag">02 · Get Hired</div>

            <h3 className="opp-card-title">
              Your next role in architecture or design is one application away.
            </h3>

            <p className="opp-card-desc">
              Smart job matching, portfolio reviews, and placement support that
              puts you ahead of the competition.
            </p>

          <a href={portalLink("/student-register")} className="opp-card-cta">
              Register to Apply  <span className="opp-card-arrow">→</span>
            </a>
          </div>
        </div>

        {/* Card 3 */}
        <div className="opp-card">
          <div
            className="opp-card-img"
            style={{
              backgroundImage:
                "url('https://images.unsplash.com/photo-1556761175-b413da4baf72?w=900&q=70')",
            }}
          ></div>

          <div className="opp-card-overlay"></div>

          <div className="opp-card-body">
            <div className="opp-card-tag">03 · Hire Talent</div>

            <h3 className="opp-card-title">
              Find design talent that's ready to work from day one.
            </h3>

            <p className="opp-card-desc">
              Vetted profiles, skill-based screening, and a pipeline of trained
              professionals.
            </p>

            <a href={portalLink("/company-login")} className="opp-card-cta">
              Post a Job <span className="opp-card-arrow">→</span>
            </a>
          </div>
        </div>

        {/* Card 4 */}
        <div className="opp-card">
          <div
            className="opp-card-img"
            style={{
              backgroundImage:
                "url('https://images.unsplash.com/photo-1543269865-cbf427effbad?w=900&q=70')",
            }}
          ></div>

          <div className="opp-card-overlay"></div>

          <div className="opp-card-body">
            <div className="opp-card-tag">04 · Partner With IPDI</div>

            <h3 className="opp-card-title">
              Colleges and firms that shape India's design future.
            </h3>

            <p className="opp-card-desc">
              Co-create curriculum, run placement drives, and build your
              employer brand among tomorrow's designers.
            </p>

            <a
              href={portalLink("/college-register")} className="opp-card-cta">
              Become a Partner <span className="opp-card-arrow">→</span>
            </a>


            
          </div>
        </div>
        {/* Card 5 */}
        {/* <div className="opp-card">
          <div
            className="opp-card-img"
            style={{
              backgroundImage:
                "url('https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=900&q=70')",
            }}
          ></div>

          <div className="opp-card-overlay"></div>

          <div className="opp-card-body">
            <div className="opp-card-tag">05 · Build Connections</div>

            <h3 className="opp-card-title">
              A network built for the AEC world — not the tech world.
            </h3>

            <p className="opp-card-desc">
              Connect with industry leaders, collaborators, mentors, and peers
              who speak your language.
            </p>

            <a href="#trainers" className="opp-card-cta">
              Join Network <span className="opp-card-arrow">→</span>
            </a>
          </div>
        </div> */}
      </div>

      <div className="opps-bottom-space"></div>
    </section>
  );
}

export default Opportunities;